import axios from "axios";
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const getVersionDifference = async (resourceId, newVersionNumber, oldVersionNumber,
    newHistoryId, oldHistoryId, justTheDifferences, apiToken = null) => {
    console.log("CALLING SERVER with getversiondifference")
    return await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            "functionid": "getversiondifference",
            "apiToken": apiToken,
            'resourceid': resourceId,
            'versionnew': newVersionNumber,
            'versionold': oldVersionNumber,
            'versionnewid': newHistoryId,
            'versionoldid': oldHistoryId,
            'onlydifferences': justTheDifferences ?? true
        },
    }).then((resp) => {
        if (resp?.data) {
            //resp.data is { 'success': true, 'jsonDifferences': [] }
            if (resp.data.success && resp.data.jsonDifferences) {
                return resp.data.jsonDifferences;
            } else {
                console.log("FAILED RESPONSE from getversiondifference call")
                return [];
            }
        }
        console.log("NO RESPONSE from getversiondifference call");
        return [];
    }).catch((error) => { console.log(error); return []; });
}

const getHistoryVersionOfResource = async (resourceId, selectedVersion, historyid, apiToken = null) => {
    console.log("CALLING SERVER with gethistoryversionofresource")
    return await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'gethistoryversionofresource',
            'idToken': "",
            'resourceid': resourceId,
            'version': selectedVersion,
            'historyid': historyid,
            "apiToken": apiToken
        }
    }).then((resp) => {
        if (resp?.data) {
            //console.log(resp.data)
            //resp.data is { 'success': true, 'fhirjsonstring': "", 'resourcetype': "", 'status': "", "found": true }
            //resp.data is {success: true,
            //  fhirjsonstring: '{\n  "resourceType": "Composition",\n  "meta": {\n   …"display": "Brian S. Alper, MD, MSPH"\n    }\n  ]\n}',
            //  resourcetype: 'Composition', status: 'active', found: true}
            if (resp.data.success) {
                return resp.data;
            } else {
                console.log("FAILED RESPONSE from gethistoryversionofresource call")
                return {};
            }
        }
        console.log("NO RESPONSE from gethistoryversionofresource call");
        return {};
    }).catch((error) => { console.log(error); return {}; });
}

const loadResourceVersionList = async (resourceId, apiToken = null) => {
    console.log("CALLING SERVER with loadResourceVersionList")
    return await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'getresourceversionlist',
            'idToken': "",
            'resourceid': resourceId,
            "apiToken": apiToken
        }
    }).then((resp) => {
        if (resp?.data) {
            if (resp.data.success && resp.data.resourceversionlist) {
                //resp.data is { 'success': true, 'resourceversionlist': [] }
                return resp.data.resourceversionlist;
            } else {
                console.log("FAILED RESPONSE from loadResourceVersionList call")
                return [];
            }
        }
        console.log("NO RESPONSE from loadResourceVersionList call");
        return [];
    }).catch((error) => { console.log(error); return []; });
}

export { getVersionDifference, getHistoryVersionOfResource, loadResourceVersionList };